import type { PropsWithChildren } from 'react';
import getFormattedCurrentDate from '@/utils/getFormattedCurrentDate';

interface LegalPageWrapperProps extends PropsWithChildren {
  title: string;
}

const LegalPageWrapper = ({ children, title }: LegalPageWrapperProps) => {
  return (
    <div className="bg-gradient-to-r from-[#DCECFB] via-[#F0F4D4] to-[#FAF3E0] p-8 rounded-lg shadow-lg">
      <div className="space-y-8 text-[#1C1C1C]">
        <div className="flex flex-col md:flex-row items-baseline justify-between">
          <h1 className="text-4xl font-bold">{title}</h1>
          <p className="text-lg">Effective date: {getFormattedCurrentDate()}</p>
        </div>
        <div className="prose prose-lg mx-auto">{children}</div>
      </div>
    </div>
  );
};

export default LegalPageWrapper;
